export const routes = {
  authCallback: () => '/authentication/callback',
  landing: () => '/',
  allProjects: () => '/projects',
  archivedProjects: () => '/projects/archive',
  createProject: () => '/projects/inputs',
  projectInputs: (projectId) => `/projects/${projectId}/inputs`,
  projectOutputs: (projectId) => `/projects/${projectId}/outputs`,
  exportProject: (projectId) => `/projects/${projectId}/export`,
  dashboard: (projectId) => `/projects/${projectId}/dashboard`,
  compareProjects: (projectId, otherProjectId) => `/projects/${projectId}/compare/${otherProjectId}`,
  usersAdministration: () => '/administration/users',
  groupsAdministration: () => '/administration/groups'
};
